export const phoneCountries = [
  { value: 'UA', label: 'Ukraine (+380)' },
  { value: 'MD', label: 'Moldova (+373)' },
  { value: 'RO', label: 'Romania (+40)' },
  { value: 'PL', label: 'Poland (+48)' },
  { value: 'AD', label: 'Andorra (+376)' },
  { value: 'AE', label: 'United Arab Emirates (+971)' },
  { value: 'AL', label: 'Albania (+355)' },
  { value: 'AM', label: 'Armenia (+374)' },
  { value: 'AR', label: 'Argentina (+54)' },
  { value: 'AT', label: 'Austria (+43)' },
  { value: 'AU', label: 'Australia (+61)' },
  { value: 'AZ', label: 'Azerbaijan (+994)' },
  { value: 'BA', label: 'Bosnia and Herzegovina (+387)' },
  { value: 'BE', label: 'Belgium (+32)' },
  { value: 'BG', label: 'Bulgaria (+359)' },
  { value: 'BR', label: 'Brazil (+55)' },
  { value: 'BY', label: 'Belarus (+375)' },
  { value: 'CA', label: 'Canada (+1)' },
  { value: 'CH', label: 'Switzerland (+41)' },
  { value: 'CL', label: 'Chile (+56)' },
  { value: 'CN', label: 'China (+86)' },
  { value: 'CO', label: 'Colombia (+57)' },
  { value: 'CY', label: 'Cyprus (+357)' },
  { value: 'CZ', label: 'Czechia (+420)' },
  { value: 'DE', label: 'Germany (+49)' },
  { value: 'DK', label: 'Denmark (+45)' },
  { value: 'EE', label: 'Estonia (+372)' },
  { value: 'EG', label: 'Egypt (+20)' },
  { value: 'ES', label: 'Spain (+34)' },
  { value: 'FI', label: 'Finland (+358)' },
  { value: 'FR', label: 'France (+33)' },
  { value: 'GB', label: 'United Kingdom (+44)' },
  { value: 'GE', label: 'Georgia (+995)' },
  { value: 'GR', label: 'Greece (+30)' },
  { value: 'HR', label: 'Croatia (+385)' },
  { value: 'HU', label: 'Hungary (+36)' },
  { value: 'ID', label: 'Indonesia (+62)' },
  { value: 'IE', label: 'Ireland (+353)' },
  { value: 'IL', label: 'Israel (+972)' },
  { value: 'IN', label: 'India (+91)' },
  { value: 'IS', label: 'Iceland (+354)' },
  { value: 'IT', label: 'Italy (+39)' },
  { value: 'JP', label: 'Japan (+81)' },
  { value: 'KR', label: 'South Korea (+82)' },
  { value: 'KZ', label: 'Kazakhstan (+7)' },
  { value: 'LT', label: 'Lithuania (+370)' },
  { value: 'LU', label: 'Luxembourg (+352)' },
  { value: 'LV', label: 'Latvia (+371)' },
  { value: 'MA', label: 'Morocco (+212)' },
  { value: 'ME', label: 'Montenegro (+382)' },
  { value: 'MK', label: 'North Macedonia (+389)' },
  { value: 'MT', label: 'Malta (+356)' },
  { value: 'MX', label: 'Mexico (+52)' },
  { value: 'NL', label: 'Netherlands (+31)' },
  { value: 'NO', label: 'Norway (+47)' },
  { value: 'NZ', label: 'New Zealand (+64)' },
  { value: 'PH', label: 'Philippines (+63)' },
  { value: 'PT', label: 'Portugal (+351)' },
  { value: 'RS', label: 'Serbia (+381)' },
  { value: 'SA', label: 'Saudi Arabia (+966)' },
  { value: 'SE', label: 'Sweden (+46)' },
  { value: 'SG', label: 'Singapore (+65)' },
  { value: 'SI', label: 'Slovenia (+386)' },
  { value: 'SK', label: 'Slovakia (+421)' },
  { value: 'TH', label: 'Thailand (+66)' },
  { value: 'TR', label: 'Türkiye (+90)' },
  { value: 'US', label: 'United States (+1)' },
  { value: 'UZ', label: 'Uzbekistan (+998)' },
  { value: 'VN', label: 'Vietnam (+84)' },
  { value: 'ZA', label: 'South Africa (+27)' },
];
